import React from 'react'
import Styles from "../../../../scss/payments.module.scss";
import {ReactComponent as SuccessSquareSVG} from "../../../../assets/images/icon-Tick-square.svg";
import {ReactComponent as InfoSquareSVG} from "../../../../assets/images/icon-Info-square.svg";
interface IPaymentsStatus{
  status:string;
  message:string;
}
const PaymentsStatus:{ [key: string]: any }= {
  Inactive:{
    color:"#F65164",
    backgroundColor:"#F3DCE3",
    Icon:<InfoSquareSVG fill="#F65164"/>
  },
  Inprogress:{
    color:"#1D8BF7",
    backgroundColor:"#DCEFFF",
    Icon:<InfoSquareSVG fill="#1D8BF7"/>
  },
  Active:{
    color:"#29D985",
    backgroundColor:"#D8F0EA",
    Icon:<SuccessSquareSVG/>
  }
}
export default function PaymentStatus({status,message}:IPaymentsStatus) {
  const {Icon,color,backgroundColor} = PaymentsStatus[status];
  return (
    <div className={Styles.PaymentsStatusContainer} style={{backgroundColor:backgroundColor}}>
      <p style={{color:color}}>
         {message}
      </p>
      {Icon}
    </div>
  )
}
